module.exports = __webpack_public_path__ + "img/6.70e22a76.jpg";